

const template = require('employer/templates/payroll/stepTwo/Summary.ejs');
const PaginatedList = require('commons/views/PaginatedList.js');
const Decimal = require('decimal.js');

module.exports = PaginatedList.extend({
    initialize: function(options) {
        this.options = _.defaults(options || {}, {});
        this.collection.on('sync', this.render, this);
        this.collection.fetchPage(undefined, {validate: false});
        return this;
    },

    render: function() {
        return Promise.all(this.collection.map(
            payslip => {
                return payslip.fetchDetails(999, false)
                    .then(() => {
                        return payslip.fetchEmployee();
                    }).then(employee => employee.fetchPosition());
            }
        )).then(() => {
            this.$el.html(template({
                payroll: this.model,
                totals: {
                    mtd: new Decimal(this.model.get('mtd') || 0)
                        .plus(this.model.get('cp38') || 0)
                        .toDP(2, Decimal.ROUND_HALF_UP)
                        .toNumber(),
                    epf: new Decimal(this.model.get('employerEpf') || 0)
                        .plus(this.model.get('employeeEpf') || 0)
                        .toDP(2, Decimal.ROUND_HALF_UP)
                        .toNumber(),
                    socso: new Decimal(this.model.get('employerSocso') || 0)
                        .plus(this.model.get('employeeSocso') || 0)
                        .toDP(2, Decimal.ROUND_HALF_UP)
                        .toNumber(),
                    eis: new Decimal(this.model.get('employerEis') || 0)
                        .plus(this.model.get('employeeEis') || 0)
                        .toDP(2, Decimal.ROUND_HALF_UP)
                        .toNumber()
                },
                company: this.model.getCompany(),
                payslips: this.collection,
                pagination: this.collection.getPaginationInfo(),
                pageTotals: this.collection.getTotals(),
                // The hack here is to enable the MTD tooltip for the hidden
                // payrollpanda company. Needed to get that done in less than
                // a couple of hours so I hardcoded the ID. Sorry!
                mtdTooltip: (
                    app.user.isAdmin() ||
                    [
                        'KoPWwKrGwV', 'LEvydMX0ZJ', '0e59RwHVjb', 'AsJarFrvEQ',
                        'zJT6Mg83es', 'MKlfhlqFCT'
                    ].indexOf((app.company || {}).id) >= 0
                )
            }));

            return PaginatedList.prototype.render.apply(this, arguments);
        });
    },

    show: function() {},
});



// WEBPACK FOOTER //
// ./app/employer/views/payroll/stepTwo/Summary.js